__turbopack_context__.v({
  "container": "z7ldwW_container",
  "text": "z7ldwW_text",
});
